import PropTypes from 'prop-types';

const packageTrackerModel = () => {
  PropTypes.shape({
    hasMultipleResults: PropTypes.bool,
    packageInfo: {
      companyHash: PropTypes.string,
      companyName: PropTypes.string,
      packageId: PropTypes.number,
      trackingKey: PropTypes.string
    },
    redispatchInfo: {
      trackingCode: PropTypes.string,
      maxPickupTime: PropTypes.number
    },
    eta: PropTypes.number,
    currentStatus: {
      error: PropTypes.number,
      inProgress: PropTypes.bool,
      destination: PropTypes.string,
      type: PropTypes.string
    },
    shipperStatus: {
      code: PropTypes.number,
      label: PropTypes.string,
      description: PropTypes.string,
      actionRequired: {
        reasonLabel: PropTypes.string,
        reasonDescription: PropTypes.string
      }
    },
    destinationInfo: {
      firstLine: PropTypes.string
    },
    canAuthenticate: PropTypes.bool
  });
};

export default packageTrackerModel;
